import { apiService } from './api';

export interface ImpersonationConsultantSummary {
  id: string;
  name: string;
  email: string;
  consultancy_id: string | null;
  consultancy_name: string | null;
}

export interface ImpersonationFacilityManagerSummary {
  id: string;
  name: string;
  email: string;
  client_id: string | null;
}

export interface ImpersonationClientSummary {
  id: string;
  name: string;
  consultancy_id: string | null;
  facility_managers: ImpersonationFacilityManagerSummary[];
}

export type ImpersonationTargetRole =
  | 'consultant'
  | 'client'
  | 'facility_manager';

export interface ImpersonationSession {
  id: string;
  actor_user_id: string;
  target_user_id: string;
  target_name: string;
  target_email: string;
  target_role: ImpersonationTargetRole;
  target_consultancy_id: string | null;
  target_consultancy_name: string | null;
  target_client_id: string | null;
  target_client_name: string | null;
  started_at: string;
  ended_at: string | null;
}

export class ImpersonationService {
  async listConsultants(
    consultancyId?: string,
  ): Promise<ImpersonationConsultantSummary[]> {
    const params = consultancyId ? { consultancy_id: consultancyId } : undefined;
    return apiService.get<ImpersonationConsultantSummary[]>(
      '/impersonation/consultants',
      params,
    );
  }

  /** List clients (and their nested facility managers) the admin can act-as. */
  async listClients(
    consultancyId?: string,
  ): Promise<ImpersonationClientSummary[]> {
    const params = consultancyId ? { consultancy_id: consultancyId } : undefined;
    return apiService.get<ImpersonationClientSummary[]>(
      '/impersonation/clients',
      params,
    );
  }

  async startSession(userId: string): Promise<ImpersonationSession> {
    return apiService.post<ImpersonationSession>('/impersonation/sessions', {
      user_id: userId,
    });
  }

  async stopActiveSession(): Promise<void> {
    return apiService.delete<void>('/impersonation/sessions/active');
  }

  /** Returns the open session or null if there isn't one. */
  async getActiveSession(): Promise<ImpersonationSession | null> {
    return apiService.get<ImpersonationSession | null>('/impersonation/active');
  }
}

export const impersonationService = new ImpersonationService();
